import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import theme from '../../styles/theme';
import { TextLinkAnchor, } from './TextLinkAnchor';
import { TextLinkButton, } from './TextLinkButton';
import { TextLinkContent, } from './TextLinkContent';
const TextLink = (props) => {
    const textLinkStyles = useMemo(() => (css `
        align-items: center;
        background: none;
        border: none;
        color: ${theme.colors.accent600};
        cursor: pointer;
        display: flex;
        order: 0;
        outline: none;
        padding: 0;
        text-align: inherit;
        text-decoration: none;

        &:hover {
          color: ${theme.colors.accent600};
        }

        ${(props.type === 'tertiary' || props.type === 'tertiaryAlternate') && css `
          color: inherit;

          &:hover {
            color: inherit;
          }
        `}
      `), [
        props.type,
    ]);
    return (props.href
        ? (_jsx(TextLinkAnchor, Object.assign({}, props, { css: textLinkStyles }, { children: _jsx(TextLinkContent, Object.assign({}, props)) })))
        : (_jsx(TextLinkButton, Object.assign({}, props, { css: textLinkStyles }, { children: _jsx(TextLinkContent, Object.assign({}, props)) }))));
};
const MemoizedTextLink = memo(TextLink);
export { MemoizedTextLink as TextLink };
// MC-1068 Temporary hack for Storybook.
export default TextLink;
